var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageErrorIcon = function SvgImageErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#imageErrorIcon_svg__a)",
    fillRule: "evenodd",
    d: "M60 14.4 12 25.825 24.203 36z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#imageErrorIcon_svg__b)",
    fillRule: "evenodd",
    d: "M24.037 36.069 24 36.09V53.4l36-39-36 21.618z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#imageErrorIcon_svg__c)",
    fillRule: "evenodd",
    d: "M60 14.4 29.4 40.343 44.1 52.2z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#imageErrorIcon_svg__d)",
    d: "M29.4 40.5 24 53.4l9.3-9.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#imageErrorIcon_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M51 60.866c0 .994-6.716 1.8-15 1.8s-15-.806-15-1.8 6.716-1.2 15-1.2 15 .206 15 1.2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "imageErrorIcon_svg__a",
    x1: 28.2,
    x2: 39,
    y1: 75.3,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "imageErrorIcon_svg__b",
    x1: 42,
    x2: 21,
    y1: 42.6,
    y2: 5.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D4DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C2C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "imageErrorIcon_svg__c",
    x1: 33.3,
    x2: 91.491,
    y1: 142.8,
    y2: 8.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "imageErrorIcon_svg__d",
    x1: 74.1,
    x2: 17.7,
    y1: -4.8,
    y2: 74.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E1E5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "imageErrorIcon_svg__e",
    width: 32.4,
    height: 5.4,
    x: 19.8,
    y: 58.466,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_24221_191011",
    stdDeviation: 0.6
  })))));
};
export default SvgImageErrorIcon;